import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { useInView } from '@/hooks/use-in-view'
import { CheckCircle } from 'lucide-react'

export function CtaSection() {
  const { t } = useTranslation('landing')
  const [ref, inView] = useInView<HTMLDivElement>({ threshold: 0.3 })
  const features = t('cta.features', { returnObjects: true }) as string[]

  return (
    <section className="relative py-24 px-4 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-indigo-500/10 via-purple-500/10 to-transparent pointer-events-none" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-indigo-500/20 rounded-full blur-3xl animate-pulse-glow" />

      <div
        ref={ref}
        className={`relative z-10 max-w-4xl mx-auto text-center space-y-8 transition-all duration-700 ${
          inView ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
        }`}
      >
        <div className="space-y-4">
          <h2 className="text-4xl md:text-6xl font-bold text-white">{t('cta.title')}</h2>
          <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto">{t('cta.subtitle')}</p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 max-w-2xl mx-auto">
          {features.map((feature, index) => (
            <div key={index} className="flex items-center gap-3 text-gray-300">
              <CheckCircle className="w-5 h-5 text-emerald-400 flex-shrink-0" />
              <span>{feature}</span>
            </div>
          ))}
        </div>

        <div className="pt-4">
          <Button
            size="lg"
            className="text-lg px-12 py-6 h-auto glow-lg"
            asChild
          >
            <Link to="/login">{t('cta.button')}</Link>
          </Button>
        </div>
      </div>
    </section>
  )
}
